import React from "react";
import { Manager, Target, Popper } from "react-popper";

import styles from "./SortBy.scss";

const OPTIONS = {
  date_pitched: "Date pitched",
  name: "Name",
  skills_matched: "Skills matched"
};

class SortBy extends React.Component {
  state = {
    open: false
  };

  togglePopup = () => {
    const { open } = this.state;

    this.setState({
      ...this.state,
      open: !open
    });
  };

  closePopup() {
    this.setState({
      ...this.state,
      open: false
    });
  }

  select = key => {
    const { onSelect } = this.props;

    this.closePopup();

    onSelect(key);
  };

  render() {
    const { selected } = this.props;
    const { open } = this.state;

    return (
      <div className={styles.sortBy}>
        <span className={styles.label}>Sort by:</span>

        <Manager>
          <Target className={styles.input} onClick={this.togglePopup}>
            {OPTIONS[selected]}
          </Target>

          {open && (
            <Popper placement="bottom-start" className={styles.popup}>
              <ul>
                {Object.keys(OPTIONS).map(key => (
                  <li key={key} onClick={() => this.select(key)}>
                    {OPTIONS[key]}
                  </li>
                ))}
              </ul>
            </Popper>
          )}
        </Manager>
      </div>
    );
  }
}

export default SortBy;



// WEBPACK FOOTER //
// ./src/routes/employer/projectInformation/components/candidates/SortBy.js